import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  response: undefined,
  error: undefined,
};

export const GetDashboardStatsSlice = createSlice({
  name: "getDashboardStats",
  initialState,
  reducers: {
    getDashboardStatsRequest: (state) => {
      state.loading = true;
      state.error = undefined;
    },
    getDashboardStatsRequestSuccess: (state, action) => {
      state.loading = false;
      state.response = action.payload;
    },
    getDashboardStatsRequestError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getDashboardStatsRequest,
  getDashboardStatsRequestSuccess,
  getDashboardStatsRequestError,
} = GetDashboardStatsSlice.actions;

export default GetDashboardStatsSlice.reducer;